// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GatePassRequestTable_wrapper__XIMUY {
  padding: 24px 32px;
  background-color: white;
  border-radius: 12px;
  margin-right: 12px;
  margin-left: 12px;
}

.GatePassRequestTable_paginationBtn__NkZvD {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  color: #64748b;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
  outline: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.GatePassRequestTable_paginationBtn__NkZvD:disabled {
  background-color: #f3f4f6;
}

.GatePassRequestTable_actionBtn__nPCjF {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: transparent;
  color: #6b7280;
  padding: 4px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.5s ease;
}

.GatePassRequestTable_actionBtn__nPCjF:hover {
  background-color: #d6dbe2;
  color: #374151;
}
.GatePassRequestTable_actionBtn__nPCjF:focus {
  outline: none;
}

.GatePassRequestTable_exportBtn__YVpoi {
  min-width: 80px;
  border-radius: 8px;
  display: flex;
  gap: 8px;
  color: white;
  background-color: #020617;
  padding: 6px 12px;

  font-family: 'Inter';
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  align-items: center;
  border: none;
}
.GatePassRequestTable_exportBtn__YVpoi:hover {
  cursor: pointer;
}

.GatePassRequestTable_exportBtnContainer__id0JF {
  display: flex;
  justify-content: space-between;
  flex-direction: row !important;
}


@media (max-width: 1024px) {
  .GatePassRequestTable_wrapper__XIMUY{
    padding: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/StudentGatePass/components/GatePassRequestTable.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,wCAAwC;AAC1C;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;;EAEjB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;AAChC;;;AAGA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".wrapper {\n  padding: 24px 32px;\n  background-color: white;\n  border-radius: 12px;\n  margin-right: 12px;\n  margin-left: 12px;\n}\n\n.paginationBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  color: #64748b;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  outline: none;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n.paginationBtn:disabled {\n  background-color: #f3f4f6;\n}\n\n.actionBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background-color: transparent;\n  color: #6b7280;\n  padding: 4px;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.5s ease;\n}\n\n.actionBtn:hover {\n  background-color: #d6dbe2;\n  color: #374151;\n}\n.actionBtn:focus {\n  outline: none;\n}\n\n.exportBtn {\n  min-width: 80px;\n  border-radius: 8px;\n  display: flex;\n  gap: 8px;\n  color: white;\n  background-color: #020617;\n  padding: 6px 12px;\n\n  font-family: 'Inter';\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  align-items: center;\n  border: none;\n}\n.exportBtn:hover {\n  cursor: pointer;\n}\n\n.exportBtnContainer {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row !important;\n}\n\n\n@media (max-width: 1024px) {\n  .wrapper{\n    padding: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `GatePassRequestTable_wrapper__XIMUY`,
	"paginationBtn": `GatePassRequestTable_paginationBtn__NkZvD`,
	"actionBtn": `GatePassRequestTable_actionBtn__nPCjF`,
	"exportBtn": `GatePassRequestTable_exportBtn__YVpoi`,
	"exportBtnContainer": `GatePassRequestTable_exportBtnContainer__id0JF`
};
export default ___CSS_LOADER_EXPORT___;
